/**
 * V3 — AuthContext + Provider. Vérifie la session via /api/v3/auth/me.
 */
import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { authMe } from './api';

const AuthCtx = createContext(null);

export function V3AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const u = await authMe();
      setUser(u);
    } catch (_e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes('session_id=')) {
      const t = setTimeout(() => setLoading(false), 0);
      return () => clearTimeout(t);
    }
    Promise.resolve().then(checkAuth);
  }, [checkAuth]);

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, checkAuth }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useV3Auth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error('useV3Auth must be used inside V3AuthProvider');
  return ctx;
}
